module.exports = __webpack_public_path__ + "static/media/days-of-the-week-in-spanish.bb4763f1.jpg";